import styled from 'styled-components';

export const Container = styled.div`
  padding: 32px 16px;
`;
export const SettingsTopbar = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;
export const BackIcon = styled.img`
  margin-left: 26px;
  margin-right: 10px;
`;

export const SettingsIconBlock = styled.div`
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #6f85ff 0%, #9c58ff 100%);
  box-shadow:
    0px 4px 6px -4px #0000001a,
    0px 10px 15px -3px #0000001a;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const SettingsImg = styled.img``;
export const SettingsTitleBlock = styled.div``;
export const SettingsTitle = styled.h3`
  font-weight: 700;
  font-size: 30px;
  letter-spacing: 0.4px;
  color: #212529;
  margin-bottom: 6px;
`;
export const SettingsSubTitle = styled.p`
  font-weight: 400;
  font-size: 16px;
  color: #4a5565;
`;
export const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  margin-top: 24px;
  background: #ffffffb2;
  border: 1px solid #e2e8f099;
  box-shadow:
    0px 8px 10px -6px #0000001a,
    0px 20px 25px -5px #0000001a;
  border-radius: 24px;
  padding: 33px;
`;

export const StatCardWrapper = styled.div`
  background: ${(props) => props.bgColor || '#fff'};
  border: 1px solid ${(props) => props.borderColor || '#e0e0e0'};
  border-radius: 16px;
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);
`;

export const StatIconBlock = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background-color: ${(props) => props.iconBg || '#007bff'};
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
`;

export const StatInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StatLabel = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: ${(props) => props.labelColor || '#6c757d'};
  text-transform: uppercase;
`;

export const StatValue = styled.span`
  font-size: 24px;
  font-weight: 700;
  color: ${(props) => props.valueColor || '#212529'};
`;
export const TabsContainer = styled.div`
  display: inline-flex;
  align-items: center;
  background: linear-gradient(
    90deg,
    rgba(219, 234, 254, 0.5) 0%,
    rgba(221, 234, 254, 0.5) 7.69%,
    rgba(223, 234, 254, 0.5) 15.38%,
    rgba(225, 234, 254, 0.5) 23.08%,
    rgba(227, 233, 254, 0.5) 30.77%,
    rgba(228, 233, 254, 0.5) 38.46%,
    rgba(230, 233, 254, 0.5) 46.15%,
    rgba(232, 233, 255, 0.5) 53.85%,
    rgba(234, 233, 255, 0.5) 61.54%,
    rgba(236, 233, 255, 0.5) 69.23%,
    rgba(238, 232, 255, 0.5) 76.92%,
    rgba(239, 232, 255, 0.5) 84.62%,
    rgba(241, 232, 255, 0.5) 92.31%,
    rgba(243, 232, 255, 0.5) 100%
  );
  padding: 9px 12px;
  border-radius: 16px;
  gap: 8px;
  min-width: 282px;
  margin-top: 40px;
  margin-bottom: 12px;
`;
export const Tab = styled.div`
  padding: 5px 12px;
  font-size: 14px;
  font-weight: 500;
  color: #0a0a0a;
  background: ${(props) => (props.$isActive ? '#ffffff' : 'transparent')};
  border-radius: 14px;
  cursor: pointer;
  transition: all 0.1s ease-in-out;
  box-shadow: ${(props) =>
    props.$isActive ? '0px 2px 4px -2px #0000001A,0px 4px 6px -1px #0000001A' : 'none'};
`;
export const ActionListTitle = styled.h3`
  font-size: 20px;
  font-weight: 700;
  color: #212529;
  margin-bottom: 16px;
  text-transform: capitalize;
  padding-left: 24px;
`;
export const ActionListContainer = styled.div`
  background: #ffffffb2;
  border-radius: 24px;
  padding: 28px 32px;
  border: 1px solid #e2e8f099;
  box-shadow:
    0px 8px 10px -6px #0000001a,
    0px 20px 25px -5px #0000001a;
`;

export const ActionCardsWrapper = styled.div`
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
`;

export const SmallStatCard = styled.div`
  background: ${(props) => props.bgColor || '#f0f0f0'};
  border-radius: 16px;
  padding: 20px 17px;
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 250px;
  border: 1px solid ${(props) => props.borderColor || 'transparent'};
`;

export const SmallIconBox = styled.div`
  background-color: ${(props) => props.iconBg};
  width: 48px;
  height: 48px;
  border-radius: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
`;

export const SmallLabel = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: ${(props) => props.color};
`;

export const SmallValue = styled.span`
  font-size: 24px;
  font-weight: 700;
  color: ${(props) => props.color};
`;
export const SmallBlock = styled.div`
  display: flex;
  flex-direction: column;
`;
